if ('scrollRestoration' in history) {
	history.scrollRestoration = 'manual';
}

// region Main Events Listing
$('.events-wrap').each(function () {
	const $wrap = $(this);

	$(this).find('.events-filter').on('click', '.events-filter-button', function (e) {
		e.preventDefault();

		const $listItem = $(this).parent();
		const isActive = $listItem.hasClass('active');

		if (isActive) return;

		const category = $(this).data('category');
		const href = category === 'All' ? window.location.pathname : $(this).attr('href');

		window.history.pushState({ index: $('.events-wrap').index($wrap), category }, null, href);
		filterEvents($wrap, category);
	});

	$(this).find('.events-filter-mobile').on('change', function () {
		const category = $(this).val();
		const href = category === 'All' ? window.location.pathname : `?category=${category}`;

		window.history.pushState({ index: $('.events-wrap').index($wrap), category }, null, href);
		filterEvents($wrap, category);
	});
});

window.addEventListener('popstate', e => {
	e.preventDefault();
	if (e.state != null) {
		const { index, category } = e.state;
		filterEvents($('.events-wrap').eq(index), category);
	}
});

function filterEvents($wrap, category) {
	const $items = $wrap.find('.events-item');

	$wrap.find('.events-filter-item').removeClass('active');
	$wrap.find(`.events-filter-button[data-category="${category}"]`).parent().addClass('active');

	animateFilterItems($items, function (elem) {
		return category === 'All' || !!$(elem).data('categories').split(',').find(c => c === category);
	});
}

function animateFilterItems($items, filterFunction) {
	const count = $items.length;
	let animateCount = 0;

	$items.each(function () {
		const $item = $(this);

		animateOut($item, function () {
			animateCount++;
			if (animateCount >= count) {
				$items
					.filter(function () {
						return filterFunction(this);
					})
					.each(function () {
						animateIn(this, function () {
						});
					});
			}
		});
	});
}

function animateIn(elem, callback) {
	const $elem = $(elem);
	$elem.stop().fadeIn(300, callback);
}

function animateOut(elem, callback) {
	const $elem = $(elem);
	$elem.stop().fadeOut(300, function () {
		$(this).hide();
		if (callback) callback();
	});
}

// endregion

// region Daily Events Listing
$('.events-daily').each(function () {
	const $wrap = $(this);
	const $items = $wrap.find('.events-daily-item');

	$wrap.find('.events-daily-nav').on('click', '.events-daily-filter', function (e) {
		e.preventDefault();
		const $btn = $(this);
		const isActive = $btn.hasClass('active');

		if (isActive) return;

		$btn.siblings().removeClass('active');
		$btn.addClass('active');

		const category = $btn.data('category');

		animateFilterItems($items, function (elem) {
			return !!$(elem).data('categories').split(',').find(c => c === category);
		});
	});
});
// endregion

// region Event Share
$(document).on('click', '.event-share-button', function (e) {
	e.preventDefault();
	const url = this.href;
	const w = 500;
	const h = 300;
	const top = window.outerHeight / 2 + window.screenY - (h / 2);
	const left = window.outerWidth / 2 + window.screenX - (w / 2);

	window.open(url, 'Share This!', 'width=' + w + ',height=' + h + ', top=' + top + ', left=' + left);
});
// endregion